import React from "react";

import { useHistory } from "react-router-dom";

import Icon from "../../icon";

import * as S from "./styles";

import IProps from "./props";

const NavigateCard: React.FC<IProps> = ({
  children,
  icon,
  to,
  invertColor = false,
  title = "Cadastre-se",
}) => {
  const history = useHistory();

  const handleClick = (): void => {
    history.push(to);
  };

  const isMobile = window.innerWidth <= 768;

  return (
    <S.Container invertColor={invertColor}>
      <S.Title invertColor={invertColor}>
        <S.IconContainer onClick={handleClick}>
          <Icon
            name={icon}
            width={isMobile ? 30 : 50}
            height={isMobile ? 30 : 50}
          />
        </S.IconContainer>
        {children}
      </S.Title>
      <S.Link to={to} invertColor={invertColor}>
        {title} <Icon name="arrow-right" />
      </S.Link>
    </S.Container>
  );
};

export default NavigateCard;
